export default __webpack_public_path__ + "static/patient-guide--prostate-cancer-6f9b2ddc37e5e05a012d7861852b666c.png";